(ns ui.components.card.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/Card/styles.json
;; Source commit: cb50b7db7b017d502f47afd96a3891775e3030e8
;; ----------------------------------------------------------------------------

(def card
  {:base
   "tw2-flex tw2-w-card tw2-flex-col tw2-items-start tw2-gap-card-gap tw2-rounded-card tw2-border tw2-border-card-border-default tw2-bg-card-bg-default tw2-shadow-2xs tw2-transition-all tw2-duration-150 tw2-ease-in-out",
   :compound
   {:settings
    {:static "tw2-p-card-padding",
     :interactive
     "tw2-p-card-padding tw2-cursor-pointer hover:tw2-border-card-border-hover hover:tw2-bg-card-bg-hover hover:tw2-shadow-sm active:tw2-border-card-border-pressed active:tw2-bg-card-bg-pressed active:tw2-shadow-none"},
    :kanban
    {:interactive
     "tw2-cursor-pointer hover:tw2-border-card-border-hover hover:tw2-bg-card-bg-hover hover:tw2-shadow-sm active:tw2-border-card-border-pressed active:tw2-bg-card-bg-pressed active:tw2-shadow-none"}},
   :settings
   {:title
    "tw2-font-sans tw2-text-label-md tw2-font-semibold tw2-text-card-title-text",
    :description
    "tw2-font-sans tw2-text-label-sm tw2-text-card-description-text",
    :title-wrap "tw2-w-full",
    :description-wrap "tw2-w-full"},
   :kanban
   {:modifiers
    "tw2-gap-0 tw2-p-0 tw2-pb-card-bottom-padding tw2-shadow-xs",
    :status-bar
    {:container
     "tw2-h-card-status-bar-height tw2-w-full tw2-mb-card-status-bar-offset tw2-rounded-card tw2-border-t-[length:var(--card-status-border-width)]",
     :won "tw2-border-status-success-bar",
     :on-track "tw2-border-status-on-hold-bar",
     :lost "tw2-border-status-lost-bar"},
    :content
    {:base
     "tw2-mb-card-content-offset tw2-flex tw2-w-full tw2-flex-col tw2-items-start tw2-gap-3 tw2-px-3 tw2-pb-4",
     :no-status-bar "tw2-pt-4"},
    :header
    {:row "tw2-flex tw2-w-full tw2-items-center tw2-justify-between",
     :title-row "tw2-flex tw2-items-center tw2-gap-1",
     :title
     "tw2-font-sans tw2-text-label-md tw2-font-semibold tw2-text-card-title-text",
     :menu-trigger
     "tw2-h-3 tw2-w-3 tw2-cursor-pointer tw2-text-card-description-text"},
    :data-attribute
    {:list "tw2-flex tw2-w-full tw2-flex-col tw2-gap-1",
     :row
     "tw2-flex tw2-w-full tw2-items-baseline tw2-justify-between tw2-gap-2",
     :label
     "tw2-shrink-0 tw2-font-sans tw2-text-label-sm tw2-font-semibold tw2-text-card-text-label-attribute",
     :value
     "tw2-min-w-0 tw2-truncate tw2-text-right tw2-font-sans tw2-text-label-sm tw2-font-semibold tw2-text-card-text-attribute"},
    :footer
    {:row "tw2-flex tw2-w-full tw2-items-center tw2-justify-between",
     :meta
     "tw2-flex tw2-items-center tw2-gap-0.5 tw2-text-card-description-text",
     :meta-text "tw2-font-sans tw2-text-label-sm",
     :icon "tw2-h-3 tw2-w-3",
     :count-group "tw2-flex tw2-items-center tw2-gap-0.5",
     :right
     "tw2-flex tw2-items-center tw2-gap-2 tw2-text-card-description-text",
     :avatar "tw2-h-3 tw2-w-3 tw2-rounded-full tw2-object-cover",
     :avatar-placeholder
     "tw2-h-3 tw2-w-3 tw2-rounded-full tw2-bg-avatar-bg-default"}}})
